// Import our custom CSS
import '../scss/styles.scss'
import u from './help/util'
import {    loadUserStatus,
            registerUserStatusListener,
            editButtons } from './userutil'
import { Collapse } from 'bootstrap'

u.CSSLink('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css')

const darkMode = () =>{
    let isDark = localStorage.getItem('darkmode');
    const darkButton = u.q('#darkModeCheck')[0];
    const turnOff = () => {
        localStorage.setItem('darkmode',0)
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }

    const turnOn = () => {
        localStorage.setItem('darkmode',1)
        document.documentElement.setAttribute('data-bs-theme', 'dark')
    }

    const changeListen = function(){
        darkButton.checked ? turnOn() : turnOff();
    }

    darkButton.checked = isDark  == '1' ? true : false;
    changeListen()
    u.listen(darkButton,'change', changeListen)
};


darkMode();
loadUserStatus();

const handlers = {
    "toggle_open_class":(e)=>{
        const news_item = u.parents(e.target,'.news');
        const news_item_body = u.q('.news-item-body', news_item[0])
        news_item[0].classList.toggle('opened');
        if (news_item[0].classList.contains('opened')){
            const media = u.q('.media-container', news_item[0]);
            media.forEach((media_el)=>{
                if (media_el.classList.contains('d-none')){
                    media_el.classList.remove('d-none')
                    const img = u.q('img', media_el)[0];
                    img.onerror = function(){
                        this.classList.add('d-none')
                    };
                    img.src = img.dataset.src;
                }
            });
        }
    },
    "load_more_items":(e)=>{
        const news_block = u.parents(e.target,'.news-block')[0];
        const total = parseInt(news_block.dataset.total)
        const mbutton = u.q('.more-button', news_block)[0];
        news_block.classList.add('loading');
        mbutton.classList.add('d-none');
        const page = parseInt(mbutton.dataset.page);
        mbutton.dataset.page = page+1;
        const url = `${TXT.web_root}/${TXT.language}/p/s/${news_block.dataset.src_id}/${page}`;
        (async ()=> {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }
                const text = await response.text();
                let div = document.createElement("div");
                div.innerHTML = text;
                mbutton.before(div); 
                let total_items = u.q('.news',news_block).length
                if (total_items < total){
                    mbutton.classList.remove('d-none')
                }
                
                u.clickHandlers(handlers, news_block)
                news_block.classList.remove('loading');
            } catch (error) {
                console.error(error.message);
            }
        })();
    }
};

u.clickHandlers(handlers);

// scroll button
(function () {
    const scrollToTopBtns = u.q('#scrollToTopBtn')
    if (scrollToTopBtns.length) {
      const scrollToTopBtn = scrollToTopBtns[0]
      scrollToTopBtn.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })

      document.addEventListener('scroll', function () {
        if (window.pageYOffset > 500) {
          scrollToTopBtn.classList.add('showBtn')
        } else {
          scrollToTopBtn.classList.remove('showBtn')
        }
      })
    }
})();


u.bodyClassCallbacks({
    'home-page':function(){
      registerUserStatusListener(function(_status, current_uid){
            editButtons(current_uid);
        });
    },
    'content-page':function(){
         registerUserStatusListener(function(_status, current_uid){
            editButtons(current_uid);
        });
    },
    'news-page':function(){
        registerUserStatusListener(function(_status, current_uid){
            editButtons(current_uid);
        });
    },
    'item-page':function(){
        registerUserStatusListener(function(_status, current_uid){
            editButtons(current_uid);
        });
    },  
    'Search':function(){
        import ("./search" ).then(({search})=>{
            search();
        })
    },
    'User':function(){
        import ("./user" ).then(({user})=>{
            user();
        })
    },
    'ItemForm':function(){
        import ("./itemform" ).then(({itemform})=>{
            itemform();
        })
    },
    'Comments':function(){
        import ("./comments" ).then(({comments})=>{
            comments();
        })
    },
 
    'CommentForm':function(){
        registerUserStatusListener(function(_status, current_uid){
            if (_status){
                import ("./commentform" ).then(({commentform})=>{
                    commentform(_status);
                });
            } else {
                u.q('#comment_form_container')[0].classList.add('anonymous')
            }
        });
    },
 
    'Message_list':function(){
        import ("./message_list" ).then(({message_list})=>{
            message_list();
        })
    },
    'Contact_page':function(){
        import ("./contactform" ).then(({contactform})=>{
            contactform();
        })
    },
    'User_management':function(){
        import ("./user_management" ).then(({user_management})=>{
            user_management();
        })
    }
});
